import React from 'react';

const AboutUs = () => {
  return (
    <div className="w-full px-6 sm:px-12 md:px-16 lg:pl-20 lg:pr-12 relative min-h-[450px]">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
        {/* Left Column: Text Content */}
        <div className="lg:col-span-8 self-start pt-0 pb-6 lg:pb-8">
          {/* Main Heading - left aligned and bold */}
          <h1 className="text-left text-4xl md:text-5xl font-black text-[#5c3e21] mb-5 tracking-tight">
            ABOUT US
          </h1>

          {/* Paragraph 1 */}
          <p className="text-gray-800 text-sm sm:text-base lg:text-[17px] leading-relaxed mb-4 font-semibold md:font-medium">
            Smart Acharya is an advanced EdTech platform, redefining the future of learning. At Smart
            Acharya, we combine the power of Artificial Intelligence with modern education to create
            smarter, more personalised, and engaging learning experiences. Our platform is designed to
            help students learn better, educators teach more effectively, and institutions embrace digital
            transformation with confidence.
          </p>

          {/* Paragraph 2 */}
          <p className="text-gray-800 text-sm sm:text-base lg:text-[17px] leading-relaxed mb-4 font-semibold md:font-medium">
            We believe every learner is unique. That’s why our AI-driven solutions adapt to individual
            learning styles, provide intelligent insights, and make education more accessible, interactive,
            and efficient.
          </p>

          {/* Paragraph 3 */}
          <p className="text-gray-800 text-sm sm:text-base lg:text-[17px] leading-relaxed mb-4 font-semibold md:font-medium">
            From personalised learning support and smart assessments to virtual assistance and data-driven
            academic tools, Smart Acharya empowers the education ecosystem with innovative technology built
            for the future.
          </p>

          {/* Paragraph 4 */}
          <p className="text-gray-800 text-sm sm:text-base lg:text-[17px] leading-relaxed mb-4 font-semibold md:font-medium">
            Designed for Educators, Schools and Institutions, our solution eliminates manual exam creation,
            reduces grading time, and provides actionable insights to enhance learning outcomes. We are
            passionate to provide every learner, intelligent tools to help them succeed.
          </p>

          {/* Paragraph 5 */}
          <p className="text-gray-800 text-sm sm:text-base lg:text-[17px] leading-relaxed font-semibold md:font-medium">
            Smart Acharya is the UK home of Acharya4Life – the global knowledge marketplace built on the
            ancient Acharya-Shishya tradition. An Acharya is not merely a teacher – one who leads by the
            power of personal example, embodying the very knowledge they share. A Shishya is not merely a
            student – every human being, at every stage of life, learning ceaselessly.
          </p>
        </div>

        {/* Right Column: Absolutely positioned or aligned bottom-right Teacher Cutout */}
        <div className="hidden lg:block lg:col-span-4 relative self-end h-full">
          <img
            src="/images/what-makes-a-great-teacher-1-removebg-preview 1.png"
            alt="Teacher cutout"
            className="absolute bottom-[-32px] right-[-48px] max-h-[480px] xl:max-h-[520px] w-auto object-contain z-10"
          />
        </div>
      </div>

      {/* Mobile Teacher image placement so it stacks beautifully below the text */}
      <div className="block lg:hidden w-full pb-6 mt-4">
        <img
          src="/images/what-makes-a-great-teacher-1-removebg-preview 1.png"
          alt="Teacher cutout"
          className="w-3/4 mx-auto object-contain"
        />
      </div>
    </div>
  );
};

export default AboutUs;